import Client from '../../../clients/Client';

const Logo = Client.Logo;

export default Logo;
